import { createFileRoute, redirect } from "@tanstack/react-router";
import { variantFromLegacyPlanKind, PURCHASE_SUCCESS_PATH } from "@/lib/purchaseSuccessState";

/** Legacy `/subscription/success/{annual|short}` → per-plan thank-you URL. */
export const Route = createFileRoute("/subscription/success/$planKind")({
  beforeLoad: ({ params }) => {
    const variant = variantFromLegacyPlanKind(params.planKind);
    throw redirect({ href: PURCHASE_SUCCESS_PATH[variant], replace: true });
  },
});
